import React from 'react'
import './App.css'
import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/home'
import NavBar from './components/nav'
import Projects from './pages/projects'
import ContactPage from './pages/contactme'
function App() {
  return (
    <div className="App">
      <header>
        <NavBar />
      </header>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/contact-info" element={<ContactPage />} />
      </Routes>
    </div>
  )
}

export default App
